module.exports = __webpack_public_path__ + "img/send.55127939.svg";